const BANGLADESH_CODE = "880";

/**
 * Normalize a phone number to the international format WhatsApp requires
 * (digits only, no leading zeros). Local numbers like 0171… become
 * 880171…; numbers already in international format are left untouched.
 */
export const toWhatsAppNumber = (
  phone: string | null | undefined,
): string | null => {
  if (!phone) return null;
  const digits = phone.replace(/\D/g, "");
  if (!digits) return null;

  if (digits.startsWith("00")) return digits.slice(2);
  if (digits.startsWith(BANGLADESH_CODE)) return digits;
  if (digits.startsWith("0")) return `${BANGLADESH_CODE}${digits.slice(1)}`;
  return digits;
};